import React from "react";

export default function BackArrowIcon({
  color = "#170738",
  onClick,
  className,
}) {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="M-6.02014e-07 6.99804C3.54002e-05 6.84862 0.0319938 6.70093 0.0937349 6.56486C0.155476 6.42878 0.245575 6.30747 0.357999 6.20904L6.293 0.409043C6.38264 0.31389 6.49128 0.238636 6.61186 0.188161C6.73245 0.137686 6.86231 0.113116 6.993 0.116042C7.12516 0.115116 7.2562 0.140399 7.37853 0.190427C7.50086 0.240455 7.61206 0.314236 7.7057 0.407505C7.79934 0.500775 7.87357 0.611681 7.92408 0.733813C7.9746 0.855944 8.0004 0.986878 8 1.11904C7.99924 1.25421 7.97152 1.38787 7.91847 1.51218C7.86541 1.6365 7.78808 1.74899 7.691 1.84304L2.398 6.99804L7.691 12.154C7.8858 12.3449 7.99692 12.6053 8 12.878C8.0008 13.0105 7.97526 13.1419 7.92486 13.2644C7.87446 13.387 7.80021 13.4983 7.70642 13.5919C7.61263 13.6855 7.50118 13.7595 7.37853 13.8097C7.25589 13.8598 7.1245 13.8851 6.992 13.884C6.86131 13.887 6.73146 13.8624 6.61087 13.8119C6.49028 13.7614 6.38164 13.6862 6.292 13.591L0.356999 7.79104C0.246721 7.69007 0.158186 7.56767 0.0968049 7.43132C0.0354236 7.29498 0.00248437 7.14755 -6.02014e-07 6.99804Z"
        fill={color}
      />
    </svg>
  );
}
